import { DOCUMENT, isPlatformBrowser, isPlatformServer } from '@angular/common';
import {
 ChangeDetectorRef,
 Component,
 ElementRef,
 HostListener,
 Inject,
 OnDestroy,
 OnInit,
 PLATFORM_ID,
 ViewChild,
 WritableSignal,
 afterNextRender,
 computed,
 effect,
 inject,
 signal,
 DestroyRef,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@core/services/authentication/auth.service';
import { HotelSummaryModel, SimilarHotelsModel } from '@models/hotel';
import { AvailableDateModel, ComboRooms, RoomInfo, RoomModel, RoomsApiModel } from '@models/room';
import { NotificationService } from '@shared/components/notification/notification.service';
import { LoadingService } from '@shared/services/loading.service';
import { ModalService } from '@shared/services/modal.service';
import { SearchBoxService } from '@shared/services/serach-box.service';
import { SwiperService } from '@shared/services/swiper-config.service';
import {
 BehaviorSubject,
 Observable,
 Subject,
 Subscription,
 fromEvent,
 of,
 skipWhile,
 take,
 takeUntil,
 tap,
} from 'rxjs';
import { LoginRegisterUiService } from '../../login-register/login-register-ui.service';
import { WINDOW } from '../accommodation-info.module';
import { HotelInfoUiService } from '../services/hotel-info-ui.service';
import { SearchResultUiService } from '../../search-result/services/search-result-ui.service';
import { isActiveModalComponent } from '../components/isActive-modal/isActive-modal.component';
import { WebengageService } from '@core/services/webengage.service';
import { MomentService } from '@core/services/moment.service';
import { DatepickerService } from '@shared/services/datepicker.service';
import { GetUserProfileResponse } from '@core/models/DTOs/userProfile.dto';
import { AccommodationBaseClass } from '@core/base/accommodation-base';
import { AutocompleteService } from '@shared/services/autocomplete.service';
import { PersianToEnglishRegexPipe } from '@shared/pipes/persianToEnglish.pipe';
import { debug } from 'console';

@Component({
 selector: 'iho-ecolodge-info',
 templateUrl: './ecolodge-info.component.html',
 styleUrls: ['./ecolodge-info.component.scss'],
 // changeDetection : ChangeDetectionStrategy.OnPush,
})
export class EcolodgeInfoComponent extends AccommodationBaseClass implements OnInit, OnDestroy {
 hotelInfoSummary: HotelSummaryModel = {} as HotelSummaryModel;
 hotelRooms$?: Observable<RoomsApiModel>;
 hotelRooms: RoomsApiModel = {} as RoomsApiModel;
 loadingFavorite = false;
 modalService = inject(ModalService);
 browserBackSubscription!: Subscription;
 hotelSummeryFetched = false;
 upperSimilarSection: WritableSignal<boolean> = signal(false);
 lowerSimilarSection: WritableSignal<boolean> = signal(true);
 userData!: WritableSignal<GetUserProfileResponse>;
 persianToEnglishPipe = inject(PersianToEnglishRegexPipe);
 affixText = computed(() =>
  !this.datepickerService._startDate() || !this.datepickerService._endDate()
   ? 'انتخاب تاریخ سفر'
   : this.searchBoxService.accommodation() == 'ecolodge' && this.datepickerService._nop() == 0
   ? 'انتخاب نفرات'
   : 'اقدام به رزرو'
 );
 showNopModal = signal(false);

 similarHotels$?: Observable<{
  CardHeaderPartial: any;
  Hotels: SimilarHotelsModel[];
 }>;
 otherRooms$?: Observable<{
  CardHeaderPartial: any;
  Hotels: SimilarHotelsModel[];
 }>;

 isFavorite = false;
 tabSelection = new BehaviorSubject<any>(0);
 tabScroll = new BehaviorSubject<any>(0);
 private destroy$ = new Subject();
 pdpTotalPrice = computed(() => this.pdpUiService.ecolodgTotalPrice());

 similarHotelsLoaded = false;
 dialog = inject(MatDialog);
 selectedRooms?: RoomInfo[] = undefined;
 roomsLoading = false;
 openModalCounter: number = 0;
 lowestSelectedRoomsPrice = 0;
 scrolledSection = signal<{
  index: number;
  fragment?: boolean | undefined;
  scrolled?: boolean;
  name?: string;
 }>({ index: 0, fragment: false, scrolled: false });
 scrollToTabPending = signal(false);
 fragmentTabPending = signal(false);
 private debounceTimer: any;
 modalOpenStatus = false;
 showSearchBar = false;
 navigatorVal = false;
 CalenderDetails: any = {};
 isCalenderPriceFetched = signal(false);
 dataRooms?: RoomsApiModel;
 roomInfo = {} as any;
 comboRooms?: {
  comboId: string;
  rooms: { secondId: number; secondName: string; secondImage: string } & RoomModel;
 };
 comboRoomsFromApi = computed(() => this.pdpUiService.comboRooms());
 hideCombos = false;
 disableComboBtn = false;
 cityId = '';
 navigatorVall: any = isPlatformBrowser(this.platformId)
  ? /Android|iPhone/.test(this.window.navigator.userAgent)
  : undefined;

 scrollSpySubscription!: Subscription;
 csrStatus = signal(false);
 alreadyTracked: WritableSignal<boolean> = signal(false);
 showInitRoom = true;

 constructor(
  private cdref: ChangeDetectorRef,
  @Inject(WINDOW) private window: Window,
  @Inject(PLATFORM_ID) private platformId: Object,
  @Inject(DOCUMENT) private document: Document,
  private webengageService: WebengageService,
  private momentService: MomentService,
  private datePickerService: DatepickerService
 ) {
  super();
  afterNextRender(() => {
   if (this.navigatorVall) {
    const rayachatNode = document.getElementById('raychat_widget') as HTMLElement;
    if (rayachatNode) rayachatNode.style.transition = '0.3s ease-in-out all';
    if (rayachatNode) rayachatNode.style.bottom = '0px';
   }
   this.loadingService.resetRefreshModalTimer('pdp');
  });
  effect(() => {
   if (this.pdpTotalPrice()) {
    this.lowestSelectedRoomsPrice =
     this.pdpUiService.lowestRoomPrice == 0
      ? this.pdpTotalPrice().finalPrice
      : this.pdpUiService.lowestRoomPrice;
   }
  });

  effect(() => {
   this.userData = this.authService.getUserData();
  });
  effect(() => {
   if (this.modalService.isAnyModalOpen() !== undefined) {
    this.modalOpenStatus = true;
    setTimeout(() => {
     this.modalOpenStatus = false;
    }, 100);
   }
  });

  if (isPlatformBrowser(platformId)) {
   this.navigatorVal = /Android|iPhone/.test(this.window.navigator.userAgent);
   this.csrStatus.set(true);
effect(()=>{
  if (this.route.snapshot.queryParams['refer'] === 'hotelinfo') {
    this.similarHotelsLoaded = false;
  }
})
   effect(
    () => {
       let startDate = this.route.snapshot.queryParams['date'] ? this.route.snapshot.queryParams['date'] :
        this.datePickerService._startDate();
       let endDate = this.route.snapshot.queryParams['endDate'] ? this.route.snapshot.queryParams['endDate'] :
        this.datePickerService._endDate();
      this.hotelInfoSummary = this.pdpUiService.hotelInfo();
      this.trackHotelInfo()
       if (Object.entries(this.hotelInfoSummary).length && this.hotelInfoSummary) {
      this.hotelSummeryFetched = true;
      this.pdpUiService.hosueId = +this.hotelInfoSummary.HouseId;
      // here we have got the accommodation data
       this.pdpUiService
         .getEcolodgeCalenderDetails(
           {
             StartDate: startDate,
             EndDate: endDate,
           },
           {
             hotelId: this.hotelInfoSummary.HotelId?.toString(),
             houseId: this.hotelInfoSummary.HouseId?.toString(),
             type: this.hotelInfoSummary.Type.toString(),
           },
           true
         )
         .subscribe((details: any) => {
           ('in ecolodge calender subscription');
           this.roomInfo = details.Room?.RoomContainer[0]?.RoomInfos[0];
           this.pdpUiService.ecolodgeRoomInfo.set([
             {
               id:
                 this.hotelInfoSummary?.Type == 1
                   ? details.Room?.RoomContainer[0]?.Id
                   : this.hotelInfoSummary?.HouseId,
               quantity: 1,
               index: 0,
               nonRefundable: this.roomInfo?.RoomDetail?.NonRefundable,
             },
           ] as any);

           if (this.hotelInfoSummary.Type == 1) {
             this.datepickerService._ihoNightLimit.set(details?.LimitCountNightRange?.LimitTo);
           }

           let mappedDates: Map<string, any> = new Map();
           (this.hotelInfoSummary.Type == 2
             ? details.Days
             : details.Room.RoomContainer[0].RoomInfos[0].RoomAvailableDate.Dates
           ).forEach((eachDate: any) => {
             mappedDates.set(this.persianToEnglishPipe.transform(eachDate.DatePersian), eachDate);
           });
           //   this.getDateDetail.transform(this.datepickerService.ecolodgeCalenderDetails().Days);
           // this.datepickerService.ecolodgeCalenderDetails.set(mappedDates);
           // return mappedDates;
           this.datepickerService.setCalenderDetails(mappedDates);
           this.CalenderDetails = details;
           this.isCalenderPriceFetched.set(true);

           //  this.openDatePicker(details.Room?.RoomContainer[0]?.RoomInfos[0].RoomAvailableDate.Dates);
         });

      if (!this.similarHotelsLoaded) {
       this.getSimilarHotels();
      }

 

      this.autocompleteService.setSelectedItem({
       name: this.hotelInfoSummary.HotelHeader.FullName,
       id: this.hotelInfoSummary.HotelId,
       type: 3,
      });

      if (this.hotelInfoSummary.IsActive == false) {
       setTimeout(() => {
        this.showMyModalNotActive();
       }, 2000);
      }
      this.searchBoxService.dateRange = [
       this.hotelInfoSummary.SearchSection.StartDate,
       this.hotelInfoSummary.SearchSection.EndDate,
      ];
      this.handleFragment();
     } else this.hotelSummeryFetched = false;
    },
    { allowSignalWrites: true }
   );

   effect(() => {
    const userData = this.authService.getUserData()();
    this.handleFragment();
   });
   this.window.scrollTo({ top: 0, behavior: 'instant' });
  } else {
   // server-side handling
   let getParams = this.route.snapshot.queryParams;
   this.cityId = getParams['city'];

   // TODO remove this
   this.route.data.pipe(takeUntilDestroyed()).subscribe((routeData) => {
    this.hotelSummeryFetched = true;
    this.hotelInfoSummary = routeData['data'];

    this.searchBoxService.dateRange = [
     this.hotelInfoSummary.SearchSection.StartDate,
     this.hotelInfoSummary.SearchSection.EndDate,
    ];
   });
  }

 
  let getParams = this.route.snapshot.queryParams;
  this.cityId = getParams['city'];

  effect(() => {
   if (this.pdpUiService.selectedComboRooms().length) {
    this.disableComboBtn = true;
   } else this.disableComboBtn = false;

   if (this.comboRoomsFromApi()?.length) {
    const generateRoomInfo = (eachCombo: ComboRooms) => {
     let result: { secondId: number; secondName: string; secondImage: string } & RoomModel;
     eachCombo.rooms.forEach((eachRoom, i) => {
      const foundRoom = this.dataRooms?.room.roomContainer.find(
       (eachOrginalRoom) => eachOrginalRoom.id === eachRoom.roomId
      )!;
      // if(foundRoom) {
      let roomInfo: any;
      if (i > 0) {
       roomInfo = result;
       roomInfo['secondImage'] = eachRoom.thumbnail.webp;
       roomInfo['secondId'] = eachRoom.roomId;
       roomInfo['secondName'] = eachRoom.roomName;
       roomInfo.roomInfos.push(foundRoom.roomInfos[0]);
      } else {
       roomInfo = structuredClone(foundRoom);
      }

      roomInfo.roomInfos[i] = {
       ...roomInfo.roomInfos[i],
       noPrice: false,
       roomPrice: {
        // ...roomInfo.roomInfos[i].roomPrice,
        discount: Number(eachRoom.priceInfo.discountPercentage),
        price: {
         ...roomInfo.roomInfos[i].roomPrice.price,
         ihoPrice: eachRoom.priceInfo.ihoPrice,
         boardPrice: eachRoom.priceInfo.boardPrice,
         oldPrice: eachRoom.priceInfo.discountPercentage ? false : true, //true value will prevent cards to show discount ballon
         nights: eachRoom.priceInfo.nights,
        },
       },
      };
      result = roomInfo;
      // }
     });

     return result!;
    };

    this.comboRoomsFromApi().forEach((eachCombo) => {
     this.comboRooms = {
      comboId: eachCombo.combenationId,
      rooms: generateRoomInfo(eachCombo) as any,
     };

     this.hideCombos = this.comboRooms.rooms.roomInfos.some(
      (each) => !each.roomPrice.price.ihoPrice
     );
    });
   } else this.comboRooms = undefined;
  });
  effect(() => {
   this.lowestSelectedRoomsPrice = this.pdpUiService.lowestRoomPrice ?? 0;

   this.selectedRooms = this.pdpUiService.selectedRooms();
   if (this.selectedRooms.length) {
    this.showInitRoom = false;
   } else this.showInitRoom = true;
  });
 }

 trackHotelInfo() {
  
  let emptyRooms = 0;
  this.pdpUiService?.roomApiResponse$?.value?.room?.roomContainer.forEach((room) => {
   if (room?.roomInfos[0]?.reservable) emptyRooms++;
  }),
   this.webengageService.trackIntrack('Hotel-Viewed', {
    hotelName: this.hotelInfoSummary?.Name,
    hotelType: this.hotelInfoSummary?.HotelHeader?.TypeName ?? '',
    Price: (this.pdpUiService?.roomApiResponse$?.value?.room?.briefPrice?.ihoPrice) ?? 0,
    hotelGrade: this.hotelInfoSummary?.HotelHeader?.Star?.GradeId ?? '',
    numberOfNight: this.hotelInfoSummary?.SearchSection?.Night,
    checkInDate: this.momentService.toGergorian(this.hotelInfoSummary?.SearchSection?.StartDate),
    checkOutDate: this.momentService.toGergorian(this.hotelInfoSummary?.SearchSection?.EndDate),
    destination: this.hotelInfoSummary?.HotelHeader?.Address?.CityName,
    cityUrl: this.hotelInfoSummary.BreadCrumb[1].Url,
    hotelRate: +this.hotelInfoSummary?.HotelHeader?.Score?.ScoreNumber,
    completeCapacity: !this.pdpUiService?.roomApiResponse$?.value?.room?.roomContainer.some(
     (room) => room?.roomInfos[0]?.reservable
    ),
    roomCount: emptyRooms,
    state: this.hotelInfoSummary?.HotelHeader?.Address?.State,
    refer: this.route.snapshot.queryParamMap.get('refer') ?? ''
   });
 }

 trackReviews() {
  if (this.hotelInfoSummary.HotelHeader) {
   this.webengageService.trackIntrack('Hotel-Reviews', {
    hotelName: this.hotelInfoSummary?.HotelHeader?.FullName,
    hotelType: this.hotelInfoSummary?.HotelHeader?.TypeName,
    Price: this.pdpUiService?.roomApiResponse$?.value?.room?.briefPrice?.ihoPrice,
    hotelGrade: this.hotelInfoSummary?.HotelHeader?.Star?.GradeId,
    hotelRate: +this.hotelInfoSummary?.HotelHeader?.Score?.ScoreNumber,
    destination: this.hotelInfoSummary?.HotelHeader?.Address?.CityName,
    cityUrl: this.hotelInfoSummary?.BreadCrumb[1]?.Url,
    hotelUrl: this.hotelInfoSummary?.BreadCrumb[2]?.Url,
   });
  }
 }

 ngOnInit(): void {
  this.datePickerService.reservable.set(true);
  this.datePickerService.setState(true);
  this.datePickerService.setAllowToShow(false);

  if (isPlatformBrowser(this.platformId)) {
   fromEvent(this.map.nativeElement, 'click')
    .pipe(takeUntil(this.destroy$))
    .subscribe((_) => this.mapTrack());

   fromEvent(this.comments.nativeElement, 'click')
    .pipe(takeUntil(this.destroy$))
    .subscribe((_) => this.trackReviews());

   //history.pushState(null, '');

   setTimeout(() => {
    this.window.scrollTo({ top: 0, behavior: 'instant' });
   }, 100);
   //this.handleBackaction();
  }
  this.sections = [
   {
    name: 'generalinfo',
    el: this.generalinfo,
   },
   {
    name: 'calender',
    el: this.calender,
   },
   {
    name: 'rules',
    el: this.rules,
   },
   {
    name: 'map',
    el: this.map,
   },
   {
    name: 'comments',
    el: this.comments,
   },
  ];

  let config = {
   slide: 'auto',
   width: 200,
   //  autoWidth: true,
   //  slidesPerView: 2,
   pagination: {
    enabled: false,
    clickable: false,
   },
  };
  this.config = this.swiperService.SwiperConfig(config);
 }

 getSimilarHotels() {
  this.similarHotelsLoaded = true;

  if (this.hotelInfoSummary.HotelId || this.hotelInfoSummary.HouseId) {
   this.similarHotels$ = this.pdpUiService
    .getSimilarAccommodation(
     this.hotelInfoSummary.HotelId,
     this.hotelInfoSummary.HouseId,
     this.hotelInfoSummary.Type
    )
    .pipe(take(1));
  }
  if (this.hotelInfoSummary.ParentId) {
   this.otherRooms$ = this.pdpUiService
    .getOtherRooms(+this.hotelInfoSummary.ParentId, this.hotelInfoSummary.Type)
    .pipe(take(1));
  }
 }

 mapTrack() {
  this.webengageService.trackIntrack('map-clicked', {
   hotelName: this.hotelInfoSummary.HotelHeader.FullName,
   numberOfNight: this.hotelInfoSummary.SearchSection.Night,
   checkInDate: this.momentService.toGergorian(this.hotelInfoSummary.SearchSection.StartDate),
   checkOutDate: this.momentService.toGergorian(this.hotelInfoSummary.SearchSection.EndDate),
   destination: this.hotelInfoSummary.HotelHeader.Address.CityName,
   cityUrl: this.hotelInfoSummary.BreadCrumb[1].Url,
   hotelUrl: this.hotelInfoSummary.BreadCrumb[2].Url,
  });
 }

 backToPlp() {
  this.searchResultUiService.resetPlpResults();
  let urlBack = this.router.url.split('/')[1];
  this.datepickerService.setState(false);
  this.router
   .navigate(['/' + urlBack], {
    queryParams: {
     search_box: this.hotelInfoSummary.HotelHeader.Address.CityName,
     refer: 'iranlist',
     type:
      isPlatformBrowser(this.platformId) && this.window.location.href.includes('ecolodge')
       ? '3'
       : '1',
     city: this.cityId,
     page: 1,
    },
   })
   .finally(() => {
    this.resetRayaChat();
   });
 }

 handleFragment() {
  let sectionIndex = this.sections.findIndex((item) => item.name == this.route.snapshot.fragment);
  if (isPlatformBrowser(this.platformId))
   setTimeout(() => {
    if (sectionIndex != -1)
     this.scrolledSection.set({
      index: sectionIndex,
      scrolled: false,
      fragment: true,
     });
   }, 300);

  this.tabSelection
   .pipe(
    takeUntil(this.destroy$),
    skipWhile(() => !this.roomsLoading)
   )
   .subscribe((tabIndex) => {
    // to getSimiliarHotels Lazyily in case user navigated through tabs
    // if (tabIndex == 1 && !this.similarHotelsLoaded) this.getSimilarHotels();
    this.scrollToTabPending.set(true);
    clearTimeout(this.debounceTimer);
    this.debounceTimer = isPlatformBrowser(this.platformId)
     ? setTimeout(() => {
        this.scrollToTabPending.set(false);
       }, 800)
     : {};
    const yOffset = -60;
    if (isPlatformBrowser(this.platformId)) {
     const y =
      this.sections[tabIndex].el.nativeElement.getBoundingClientRect().top +
      this.window.pageYOffset +
      yOffset;
     this.window.scrollTo({ top: y, behavior: 'smooth' });
    }
   });
 }

 goToSimilarHotelsSection() {
  this.similarHotelsSection.nativeElement.scrollIntoView({
   behavior: 'smooth',
   block: 'start',
  });
 }

 disableFragment() {
  this.fragmentTabPending.set(true);
 }

 handleBackaction() {
  fromEvent(window, 'popstate')
   .pipe(
    takeUntil(this.destroy$),
    skipWhile(() => this.modalOpenStatus)
   )
   .subscribe((e) => {
    e.preventDefault();
    e.stopPropagation();
    this.scrollToTabPending.set(true);
    this.disableFragment();
    this.searchResultUiService.resetPlpResults();
    let urlBack = this.router.url.split('/')[1];
    this.datepickerService.setState(false);

    history.pushState(null, '');
    setTimeout(() => {
     this.router
      .navigate(['/ecolodge/', this.hotelInfoSummary.HotelHeader.Address.CityName], {
       queryParams: {
        search_box: this.hotelInfoSummary.HotelHeader.Address.CityName,
        date: this.datePickerService._startDate(),
        endDate: this.datePickerService._endDate(),
        refer: 'iranlist',
        // hid: this.hotelInfoSummary.HotelId,
        type: 3,
       },
      })
      .finally(() => {
       this.window.scrollTo({ top: 0, behavior: 'instant' });
       this.resetRayaChat();
      });
    }, 100);
   });
 }

 goToSelectedTab(selectedTab: number) {
  this.roomsLoading = true;
  this.tabSelection.next(selectedTab);
 }

 @HostListener('window:scroll', ['$event'])
 onScroll(event: Event) {
  if (!this.scrollToTabPending()) this.checkScroll();
 }

 checkScroll() {
  const scrollPosition = document.documentElement.scrollTop || document.body.scrollTop || 0;

  for (let i = 0; i < this.sections?.length; i++) {
   const sectionTop = this.sections[i]?.el?.nativeElement.offsetTop;
   const sectionHeight = this.sections[i]?.el?.nativeElement.offsetHeight;
   const sectionId = i;

   if (
    scrollPosition >= sectionTop &&
    scrollPosition < sectionTop + sectionHeight &&
    this.scrolledSection().index != sectionId
   ) {
    // to getSimiliarHotels Lazyily in case user navigated through scroll
    // if (sectionId == 1 && !this.similarHotelsLoaded) this.getSimilarHotels();
    this.scrolledSection.set({
     index: sectionId,
     scrolled: true,
     name: this.sections[sectionId].name,
    });
    break;
   }
  }
 }

 goToMap() {
  if (isPlatformBrowser(this.platformId)) {
   const yOffset = -60;
   const y = this.map.nativeElement.getBoundingClientRect().top + this.window.pageYOffset + yOffset;
   this.window.scrollTo({ top: y, behavior: 'smooth' });
  }
 }

 addToFavorite() {
  if (this.authService.getUserData()()) {
   if (!this.loadingFavorite) {
    this.loadingFavorite = true;
    // this.isFavorite = !this.isFavorite
    this.pdpUiService
     .addToFavorite()
     .pipe(takeUntil(this.destroy$))
     .subscribe((response: any) => {
      this.loadingFavorite = false;
      this.hotelInfoSummary.IsFavourite = response.data.isFavorite;
      if (this.hotelInfoSummary.IsFavourite) {
       this.webengageService.trackIntrack('add-to-fav', {
        hotelName: this.hotelInfoSummary?.HotelHeader?.FullName,
        hotelType: this.hotelInfoSummary?.HotelHeader?.TypeName,
        Price: this.pdpUiService.roomApiResponse$.value.room.briefPrice.ihoPrice,
        hotelGrade: this.hotelInfoSummary?.HotelHeader?.Star?.GradeId,
        destination: this.hotelInfoSummary?.HotelHeader?.FullName,
       });

       this.notificationService.success(
        'اضافه به علاقه مندی ها',
        'هتل به لیست علاقه مندی های شما اضافه شد'
       );
      } else {
       this.webengageService.trackIntrack('rem-from-fav', {
        hotelName: this.hotelInfoSummary?.HotelHeader?.FullName,
        hotelType: this.hotelInfoSummary?.HotelHeader?.TypeName,
        Price: this.pdpUiService.roomApiResponse$.value.room.briefPrice.ihoPrice,
        hotelGrade: this.hotelInfoSummary?.HotelHeader?.Star?.GradeId,
        destination: this.hotelInfoSummary?.HotelHeader?.FullName,
       });
       this.notificationService.success(
        'حذف از علاقه مندی ها',
        'هتل از لیست علاقه مندی های شما حذف شد'
       );
      }
      this.cdref.detectChanges();
     });
   }
  } else {
   this.loginRegisterUiService.showMyModal();
  }
 }

 newPdpSearch() {
  this.resetEcolodgeInfoResults();
 }

 navToPlp(url: string, ev: Event) {
  this.searchResultUiService.resetPlpResults();
  ev.preventDefault();
  this.router
   .navigate([url], {
    queryParams: {
     search_box: this.hotelInfoSummary.HotelHeader.Address.CityName,
     date: this.datePickerService._startDate(),
     endDate: this.datePickerService._endDate(),
     refer: 'iranlist',
     city: this.cityId,
     type: 1,
     page: 1,
    },
   })
   .finally(() => {
    this.resetRayaChat();
   });
 }

 showMyModalNotActive() {
  const dialogRef = this.dialog.open(isActiveModalComponent, {
   panelClass: [
    'isActive-modal',
    'custom-modal',
    'w-screen',
    'lg:w-[450px]',
    'h-screen',
    '!max-w-full',
    'lg:h-auto',
    '',
   ],
   data: {
    BreadCrumb: this.hotelInfoSummary.BreadCrumb,
    SearchSection: this.hotelInfoSummary.SearchSection,
   },
   autoFocus: false,
  });
 }

 ngOnDestroy() {
  this.alreadyTracked.set(false);
  if (isPlatformBrowser(this.platformId)) {
   this.destroy$.next('');
   this.destroy$.complete();
   this.resetEcolodgeInfoResults();
  }
 }

 resetRayaChat() {
  if (this.navigatorVall) {
   const rayachatNode = document.getElementById('raychat_widget') as HTMLElement;
   if (rayachatNode) rayachatNode.style.transition = '0.3s ease-in-out all';
   if (rayachatNode) rayachatNode.style.bottom = '0px';
  }
 }
 scrollToRoom() {
  const yOffset = -60;
  this.router.navigate([], {
   fragment: 'rooms',
   queryParamsHandling: 'preserve',
   relativeTo: this.route,
  });
  if (isPlatformBrowser(this.platformId)) {
   const y =
    this.rooms.nativeElement.getBoundingClientRect().top + this.window.pageYOffset + yOffset;
   this.window.scrollTo({ top: y, behavior: 'smooth' });
  }
 }

 handleAffixClick(isSticky: boolean) {
  if (isSticky) {
   const yOffset = -60;
   const y =
    this.calender.nativeElement.getBoundingClientRect().top + this.window.pageYOffset + yOffset;
   this.window.scrollTo({ top: y, behavior: 'smooth' });
   return;
  }
  if (this.affixText() == 'انتخاب تاریخ سفر') {
   if (this.calender) {
    const yOffset = -60;
    const y =
     this.calender.nativeElement.getBoundingClientRect().top + this.window.pageYOffset + yOffset;
    this.window.scrollTo({ top: y, behavior: 'smooth' });
   }
  } else if (this.affixText() == 'انتخاب نفرات') {
   // this.datePickerService._allowToShow.set(false);
   this.datepickerService.setState(false);

   this.showNopModal.set(true);
  } else {
   if (
    this.datePickerService.calenderErrors().NonBookable ||
    this.datePickerService.calenderErrors().NightLimits
   ) {
    this.showNopModal.set(false);

    return;
   }
   this.goToFollowReservation();
  }
 }

 closeNopModal($event: any) {
  this.showNopModal.set(false);
  this.scrollToTabPending.set(true);
  clearTimeout(this.debounceTimer);
  this.debounceTimer = isPlatformBrowser(this.platformId)
   ? setTimeout(() => {
      this.scrollToTabPending.set(false);
     }, 800)
   : {};
  const yOffset = -60;
  if (isPlatformBrowser(this.platformId)) {
   const y =
    this.sections[1].el.nativeElement.getBoundingClientRect().top +
    this.window.pageYOffset +
    yOffset;
   this.window.scrollTo({ top: y, behavior: 'smooth' });
  }
 }

 goToFollowReservation() {
  const _payload = {
   hotelId:
    this.pdpUiService.hotelInfo().Type == 2 ? this.pdpUiService.hosueId : this.pdpUiService.hotelId,
   arrivalDate: this.datepickerService._startDate(),
   checkoutDate: this.datepickerService._endDate(),
   rooms: this.pdpUiService.ecolodgeRoomInfo(),
   type: this.pdpUiService.hotelInfo().Type,
   IsWaitingList: false,
   organizationId: null,
   Combenations: [],
   ExtraGuestCount: this.pdpUiService.ExtraGuestCount(),
   FixedGuestCount: this.pdpUiService.FixedGuestCount(),
   AccommodationType: this.searchBoxService.accommodation() == 'ecolodge' ? 2 : 1,
  };

  this.pdpUiService.getReserveUUID(_payload).subscribe((uuid) => {
   if (uuid) {
    this.webengageService.trackIntrack('Room-Select', {
    CheckInDate: this.momentService.toGergorian(this.datepickerService._startDate()),
    CheckOutDate: this.momentService.toGergorian(this.datepickerService._endDate()),
    Destination: this.pdpUiService?.hotelInfo()?.HotelHeader.Address.CityName,
    hotelName: this.pdpUiService?.hotelFullName,
    HotelId: this.pdpUiService.hotelInfo().Type == 2 ? this.pdpUiService.hosueId : this.pdpUiService.hotelId,
    Price: 0,
    RoomName: '',
    RoomNumber: 0,
    numberOfNights: this.pdpUiService?.nights,
    hotelType: this.pdpUiService?.hotelInfo()?.HotelHeader?.TypeName ?? '',
    hotelRate: +this.pdpUiService?.hotelInfo()?.HotelHeader?.Score?.ScoreNumber,
    hotelGrade: this.pdpUiService.hotelInfo()?.HotelHeader?.Star?.GradeId || 0,
    roomCapacity: 0,
  });
     window.location.href = window.location.origin + '/persian/pursuit/resid/' + uuid;
   }
  });
 }

 openDatePicker(event: AvailableDateModel[]) {
  let helper: string[] = [];
  /*
           - checking first item
        */
  if (+event[0].ReservableStatus === 2 || +event[0].ReservableStatus === 3) {
   helper.push(`${this.persianToEnglishPipe.transform(event[0].DatePersian)},3`);
  }
  if (+event[0].ReservableStatus === 4) {
   helper.push(`${this.persianToEnglishPipe.transform(event[0].DatePersian)},4`);
  }
  if (+event[0].ReservableStatus === 5) {
   helper.push(`${this.persianToEnglishPipe.transform(event[0].DatePersian)},2`);
  }
  for (let i = 1, j = 0, k = 2; i < event?.length; i++, j++, k++) {
   if (
    +event[i].ReservableStatus === 2 &&
    +event[j].ReservableStatus === 2 &&
    +event[k]?.ReservableStatus === 2
   ) {
    helper.push(`${this.persianToEnglishPipe.transform(event[i].DatePersian)},2`);
   }
   if (
    +event[i].ReservableStatus === 2 &&
    +event[j].ReservableStatus === 2 &&
    +event[k]?.ReservableStatus === 1
   ) {
    helper.push(`${this.persianToEnglishPipe.transform(event[i].DatePersian)},2`);
   }
   if (
    +event[i].ReservableStatus === 2 &&
    +event[j].ReservableStatus === 1 &&
    +event[k]?.ReservableStatus === 2
   ) {
    helper.push(`${this.persianToEnglishPipe.transform(event[i].DatePersian)},3`);
   }
   if (+event[i].ReservableStatus === 3) {
    helper.push(`${this.persianToEnglishPipe.transform(event[i].DatePersian)},3`);
   }
   if (+event[i].ReservableStatus === 4) {
    helper.push(`${this.persianToEnglishPipe.transform(event[i].DatePersian)},4`);
   }
   if (+event[i].ReservableStatus === 5) {
    helper.push(`${this.persianToEnglishPipe.transform(event[i].DatePersian)},2`);
   }
   /*
              - checking last item
            */
   if (
    +event[i].ReservableStatus === 2 &&
    +event[j].ReservableStatus === 1 &&
    event[k] === undefined
   ) {
    helper.push(`${this.persianToEnglishPipe.transform(event[i].DatePersian)},2`);
   }
   if (
    +event[i].ReservableStatus === 2 &&
    +event[j].ReservableStatus === 2 &&
    event[k] === undefined
   ) {
    helper.push(`${this.persianToEnglishPipe.transform(event[i].DatePersian)},2`);
   }
  }
  this.datePickerService.setUnReservable(helper, true);
 }

 resetEcolodgeInfoResults() {
  this.hotelSummeryFetched = false;
  this.pdpUiService.selectedRooms.set([]);
  this.pdpUiService.hotelInfo.set({} as HotelSummaryModel);
  this.loadingService.modalTimerSub?.unsubscribe();
  this.CalenderDetails = [];
  this.similarHotels$ = of([] as any);
  this.otherRooms$ = of([] as any);
  this.datePickerService.ecolodgeCalenderDetails.set(false);
  this.datePickerService.setCalenderDetails(false);
  this.datePickerService.fetchedMonthes.set([]);
  this.datepickerService.setAllowToShow(false);
  this.datepickerService.setState(false);
  this.datePickerService.calenderErrors.set({ NightLimits: false, NonBookable: false });
  setTimeout(() => {
   this.window.scrollTo({ top: 0, behavior: 'instant' });
  }, 300);
 }
}
